/**
 * Region Constants
 *
 * Default region configuration matching mobile's region.constants.ts
 */

export interface StoreRegion {
    code: string;
    id: number;
    name: string;
    num_of_stores?: number;
}

export const DEFAULT_REGION: StoreRegion = {
    code: 'VN-63',
    id: 619,
    name: 'Hà Nội',
};
